/**
 * Range slider
 * @requires https://github.com/leongersen/noUiSlider
 */

const rangeSlider = () => {

    if ('undefined' === typeof noUiSlider) {
        console.info('noUiSlider is not loaded!');
        return;
    }

    const classBound = 'has-bound-range-slider';
    const selector = `.range-slider:not(${classBound})`;
    let rangeSliderWidget = document.querySelectorAll(selector);

    //for (let element of rangeSliderWidget) {
    for (let i = 0; i < rangeSliderWidget.length; i++) {
        let element = rangeSliderWidget[i];

        if (element.classList.contains(classBound)) {
            continue;
        }

        let rangeSlider = element.querySelector('.range-slider-ui'),
                valueMinInput = element.querySelector('.range-slider-value-min'),
                valueMaxInput = element.querySelector('.range-slider-value-max'),
                triggerInput = document.createElement('input');

        triggerInput.type = 'hidden';
        triggerInput.className = 'nfwE-filter-trigger';
        element.appendChild(triggerInput);

        let ds = element.dataset;

        let options = {
            dataStartMin: parseFloat(ds.startMin),
            dataStartMax: parseFloat(ds.startMax),
            dataMin: parseInt(ds.min, 10),
            dataMax: parseInt(ds.max, 10),
            dataStep: parseFloat(ds.step) || 1,
            dataUnitPre: ds.unitPre || '',
            dataUnitPost: ds.unitPost || ''
        };

        noUiSlider.create(rangeSlider, {
            start: [options.dataStartMin, options.dataStartMax],
            connect: true,
            step: options.dataStep,
            pips: {mode: 'count', values: 5},
            tooltips: true,
            range: {
                'min': options.dataMin,
                'max': options.dataMax
            },
            format: {
                to: function (value) {
                    return options.dataUnitPre + Math.round(parseFloat(value) * 100) / 100 + options.dataUnitPost;
                },
                from: function (value) {
                    return Number(value);
                }
            }
        });

        rangeSlider.noUiSlider.on('update', (values, handle) => {
            let value = values[handle];
            value = value.match(/^\D*(\d+([.,]\d+)?)\D*$/)[1];
            if (handle) {
                valueMaxInput.value = Math.round(value * 100) / 100;
            } else {
                valueMinInput.value = Math.round(value * 100) / 100;
            }
        });

        rangeSlider.noUiSlider.on('change', (values, handle, unencoded, tap, positions, noUiSlider) => {
            // values: Current slider values (array);
            // handle: Handle that caused the event (number);
            // unencoded: Slider values without formatting (array);
            // tap: Event was caused by the user tapping the slider (boolean);
            // positions: Left offset of the handles (array);
            // noUiSlider: slider public Api (noUiSlider);
            //console.log({values, handle, unencoded, tap, positions, noUiSlider});
            let event = new Event('change', {bubbles: true});
            triggerInput.dispatchEvent(event);
        });

        valueMinInput.addEventListener('change', function () {
            rangeSlider.noUiSlider.set([this.value, null]);
        });

        valueMaxInput.addEventListener('change', function () {
            rangeSlider.noUiSlider.set([null, this.value]);
        });

        element.classList.add(classBound);
    }
};

export default rangeSlider;

rangeSlider();
